import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ErrorBoundary } from "react-error-boundary";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  

  <React.StrictMode>
    <ErrorBoundary fallback={<div>Something went wrong</div>}>
        <App />
    </ErrorBoundary>
  </React.StrictMode>
);

